// Design tokens — Supervisão (lista).
// Padrão: DESIGN_NOT_GENERIC.md (header Contatos).

export const SUPERVISAO_LISTA_DESIGN = {
  root: 'flex flex-col h-full min-h-0 w-full bg-[#f4f4f7] text-[#18181b]',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',

  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec] shrink-0',
  headerRow: 'flex flex-wrap items-center gap-2.5 py-3',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b] shrink-0 mr-1.5',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0',
  searchRow: 'flex items-center w-full sm:w-[240px] ml-auto min-w-0',
  searchField:
    'flex items-center gap-2.5 w-full h-10 px-3.5 rounded-lg border border-[#d4d4d8] bg-white transition-colors hover:border-[#b8b8c0] focus-within:border-[#8b5cf6] focus-within:ring-2 focus-within:ring-[#c4b5fd]',
  searchIcon: 'flex-shrink-0 text-[#a1a1aa] hover:text-[#6d28d9] transition-colors',
  searchClear: 'flex-shrink-0 text-[#a1a1aa] hover:text-[#b42318] transition-colors',
  searchInput:
    'flex-1 min-w-0 h-auto border-0 bg-transparent p-0 text-[14px] md:text-[14px] text-[#18181b] shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-[#a1a1aa]',

  body: 'flex-1 min-h-0 flex flex-col px-4 md:px-6 lg:px-8 pt-4 pb-6',
  controlBar: 'flex flex-wrap items-center gap-2.5 mb-3.5',
  filterField: 'min-w-0 w-full sm:w-[200px]',
  filterSelect:
    'h-10 w-full rounded-lg border border-[#d4d4d8] bg-white text-[13px] text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:ring-2 focus:ring-[#c4b5fd]',
  periodButton:
    'inline-flex h-10 w-full items-center justify-between gap-2 rounded-lg border border-[#d4d4d8] bg-white px-3.5 text-[13px] font-medium text-[#18181b] transition-colors hover:border-[#b8b8c0]',

  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonActive:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#a78bfa] bg-[#ede9fe] text-[#5b21b6]',
  viewToggle: 'inline-flex items-center gap-1',

  filterCount:
    'inline-flex h-4 min-w-4 items-center justify-center rounded px-1 text-[10px] font-semibold tabular-nums bg-[#ede9fe] text-[#5b21b6]',
  popover: 'w-80 space-y-4 p-4',
  popoverTitle: 'border-b border-[#e7e7ec] pb-2 text-[13px] font-semibold text-[#18181b]',
  popoverLabel: 'mb-1.5 block text-[13px] font-semibold text-[#18181b]',

  card: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 flex-1 min-h-0 flex flex-col',
  tabsWrap: 'border-b border-[#e7e7ec] px-2',
  tableWrap: 'flex-1 min-h-0 overflow-auto p-3',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  pagination:
    'shrink-0 border-t border-[#f0f0f3] px-3 sm:px-5 py-1 bg-[#fafafb]',

  splitRoot: 'flex gap-2.5 flex-1 min-h-0',
  statusSidebar:
    'w-[72px] min-w-[72px] flex-shrink-0 flex flex-col bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden',
  statusItem:
    'group relative w-[60px] flex flex-col items-center gap-0.5 py-2.5 rounded-xl transition-colors cursor-pointer border-2 border-transparent hover:bg-[#fafafb]',
  statusItemActive: 'shadow-none',
  statusTotal: 'border-t border-[#f0f0f3] py-2 flex justify-center',
  statusTotalValue: 'text-sm font-bold text-[#18181b]',
  statusTotalLabel: 'text-[10px] text-[#a1a1aa] font-semibold',

  chatListCard:
    'w-[380px] min-w-[340px] flex-shrink-0 flex flex-col p-0 overflow-hidden bg-white border border-[#e7e7ec] rounded-[12px]',
  loadMore:
    'w-full py-2.5 text-[13px] font-semibold text-[#6d28d9] hover:bg-[#faf8ff] transition-colors disabled:opacity-50',
  detailCard:
    'flex-1 flex flex-col min-w-0 overflow-hidden bg-white border border-[#e7e7ec] rounded-[12px]',
  emptyState: 'flex flex-col items-center justify-center flex-1 py-16 text-center px-4',
  emptyIcon:
    'mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm',
};

export default SUPERVISAO_LISTA_DESIGN;
